import React, { useContext, useEffect, useRef } from 'react';
import { setupCamera } from '../../utils';
import RootContext from '../../context';
import history from '../../history';
import { PATH_LIVENESS, PATH_NO_CAMERA, PATH_ROOT } from '../../paths';

export const VideoBase = () => {
  const videoRef = useRef();
  const { captureVideo, setVideo, setVideoParams } = useContext(RootContext);
  useEffect(() => {
    main();
    // eslint-disable-next-line
  }, [captureVideo]);

  const main = async () => {
    if (!captureVideo) return;
    // console.warn('[VideoBase].main');
    const video = await setupCamera(videoRef.current);
    if (!video) {
      console.warn('can not get video source');
      // alert(`reirect to ${PATH_ROOT}${PATH_NO_CAMERA}`);
      return history.push(`${PATH_ROOT}${PATH_NO_CAMERA}`);
    }
    setVideo(video);
    video.play();
    const { videoWidth, videoHeight } = video;
    setVideoParams({
      width: video.width,
      height: video.height,
      clientWidth: video.clientWidth,
      clientHeight: video.clientHeight,
      videoWidth,
      videoHeight,
    });
    video.width = videoWidth;
    video.height = videoHeight;
    history.push(`${PATH_ROOT}${PATH_LIVENESS}`);
  };

  return <>
    <video
      ref={videoRef}
      autoPlay muted playsInline loop style={{
        position: 'fixed',
        left: '0px',
        top: '0px',
        visibility: 'visible',
        // border: '1px solid red',
        width: '1px',
        height: '1px',
      }}
    />
  </>;
};
